import { makeRequest } from 'utils/requestLogger';

export default (data) => {
  const { user_id , live_discussion_id, start_time, content, participation_id } = data;
  makeRequest('post', `/api/transcriptions`, {
    user_id,
    live_discussion_id,
    start_time,
    content,
    participation_id
  });
};
  



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/handleSaveUserTranscript.js